import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import Button from '@/components/ui/buttons/Button';
import GradeClassNumberLabel from '@/components/ui/formats/GradeClassNumberLabel';
import Checkbox from '@/components/ui/forms/Checkbox';
import { type InvitationStudent } from '@/interfaces/invitation';

import styles from './InvitationStudentConfirmForm.module.scss';

interface Props {
  student: InvitationStudent;
}

const InvitationStudentConfirmForm: React.FC<Props> = ({ student }) => {
  const [isChecked, setIsChecked] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = () => {
    navigate('/invitations/register/input');
  };

  return (
    <>
      <div className={styles.InvitationStudentConfirmForm__Description}>
        以下の生徒について招待が届きました。{'\n'}
        よろしければチェックの上、アカウント登録にお進みください。
      </div>
      <div className={styles.InvitationStudentConfirmForm}>
        <div
          className={styles.InvitationStudentConfirmForm__StudentInformation}
        >
          <div
            className={
              styles.InvitationStudentConfirmForm__OrganizationMembershipCode
            }
          >
            {student.code}
          </div>
          <div
            className={styles.InvitationStudentConfirmForm__StudentInformations}
          >
            <div
              className={
                styles.InvitationStudentConfirmForm__StudentInformation__OrganizationName
              }
            >
              {student.organization_name}
            </div>
            <GradeClassNumberLabel
              gradeLabel={student.grade}
              classNameLabel={student.class_name ?? undefined}
              attendanceNumberLabel={student.attendance_number ?? undefined}
            />
            <div
              className={
                styles.InvitationStudentConfirmForm__StudentInformation__StudentName
              }
            >
              {student.name}
            </div>
          </div>
        </div>
        <div className={styles.InvitationStudentConfirmForm__CheckBoxArea}>
          <Checkbox
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
            role="checkbox"
          >
            <div
              className={styles.InvitationStudentConfirmForm__Checkbox__Text}
            >
              私はこの生徒の保護者であることを確認しました
            </div>
          </Checkbox>
        </div>
      </div>
      <div className={styles.SubmitButtonArea}>
        <ul className={styles.SubmitButtonArea__Note}>
          <li>
            <p>
              生徒情報（年・組・番・氏名）が誤っている場合は、招待した方にご確認ください。
            </p>
          </li>
        </ul>
        <Button
          className={styles.SubmitButton}
          color="primary"
          type="button"
          disabled={!isChecked}
          onClick={handleSubmit}
        >
          アカウント登録へ
        </Button>
      </div>
    </>
  );
};

export default InvitationStudentConfirmForm;
